module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/InfluencerExample/0_0-66a9eb0d0278623d5fae37cec3bff186.png";